<coin-v2-card
  padding="none"
  [rounding]="rounding()"
  (blur)="onTouch()">
  <div
    class="outline-container"
    [class.selected]="value"
    (click)="toggleCard()">
    <div class="checkbox-container">
      <coin-v2-checkbox
        [contrast]="value"
        [ngModel]="value"></coin-v2-checkbox>
    </div>
    <div class="content padding-{{ padding() }}">
      <ng-content></ng-content>
    </div>
  </div>
</coin-v2-card>
